import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { SimpleModal } from '@livable/saas-react-components';
import { Box } from '@mui/material';
import { getSubscriptionTermLabel } from 'src/constants/subscriptionTerm';
import { formatScheduleDate } from '../scheduleChangeDates';
import { CancelScheduleChangeContent } from './CancelScheduleChangeContent';
export const SCHEDULE_CHANGE_TYPES = {
  Cancel: {
    icon: 'cancel-event',
    labelKey: 'subscriptions.scheduleChange.cancel.label',
    effectKey: 'subscriptions.scheduleChange.cancel.effect',
    isEnabled: true,
    requiresActiveSubscription: true,
    allowsOnlyOnePending: true,
    menuDescriptionKey: 'subscriptions.scheduleChange.cancel.menu_description',
    titleKey: 'subscriptions.scheduleChange.cancel.modal_title',
    rescheduleTitleKey: 'subscriptions.scheduleChange.cancel.modal_title_reschedule',
    Content: CancelScheduleChangeContent
  },
  Pause: {
    icon: 'pause-event',
    labelKey: 'subscriptions.scheduleChange.pause.label',
    effectKey: 'subscriptions.scheduleChange.pause.effect',
    isEnabled: false,
    captionKey: 'subscriptions.scheduleChange.coming_soon'
  }
};
export const UNKNOWN_SCHEDULE_CHANGE_TYPE = {
  icon: 'calendar-clock',
  labelKey: 'subscriptions.scheduleChange.unknown.label',
  effectKey: 'subscriptions.scheduleChange.unknown.effect',
  isEnabled: false
};
export const getScheduleChangeTypeConfig = type => type && SCHEDULE_CHANGE_TYPES[type] || UNKNOWN_SCHEDULE_CHANGE_TYPE;
const getSubscriptionSummary = (t, subscription) => {
  const start = formatScheduleDate(subscription.startDate);
  const commitmentEnd = formatScheduleDate(subscription.commitmentEndDate);
  const dates = commitmentEnd ? t('subscriptions.scheduleChange.subscription_dates_committed', {
    start,
    end: commitmentEnd
  }) : t('subscriptions.scheduleChange.subscription_dates', {
    start
  });
  return [subscription.companyName, getSubscriptionTermLabel(subscription.term), start ? dates : ''].filter(Boolean).join(' · ');
};
export const ScheduleChangeModal = observer(function ScheduleChangeModal(_ref) {
  var _ref2;
  let isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Cancel' : _ref$type,
    subscription = _ref.subscription,
    scheduledChange = _ref.scheduledChange,
    onScheduled = _ref.onScheduled;
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const config = SCHEDULE_CHANGE_TYPES[type];
  const Content = config === null || config === void 0 ? void 0 : config.Content;
  if (!Content || !subscription) return null;
  const titleKey = (_ref2 = scheduledChange ? config.rescheduleTitleKey : config.titleKey) !== null && _ref2 !== void 0 ? _ref2 : '';
  return /*#__PURE__*/React.createElement(SimpleModal, {
    noFooter: true,
    variant: "middle",
    trigger: null,
    isOpen: isOpen,
    handleClose: onClose,
    title: t(titleKey),
    subTitle: getSubscriptionSummary(t, subscription)
  }, /*#__PURE__*/React.createElement(Box, {
    component: "div",
    display: "block"
  }, /*#__PURE__*/React.createElement(Content, {
    isOpen: isOpen,
    onClose: onClose,
    subscription: subscription,
    scheduledChange: scheduledChange,
    onScheduled: onScheduled
  })));
});